import { inject, observer } from "mobx-react";
import React from "react";
import styled from "styled-components";
import Loading from "../components/Loading";
import SetiTable from "../components/SetiTable";
import PitchCriteria from "../components/filters/PitchCriteria";
import StrikeZoneModelCriteria from "../components/filters/StrikeZoneModelCriteria";
import ApplyButton from "../components/filters/ApplyButton";
import FilterSidebar from "../components/layout/FilterSidebar";
import rem from "../utils/rem";

const Wrapper = styled.div`
  display: flex;
  height: calc(100vh - ${rem(60)});
`;

const TableWrapper = styled.div`
  margin-left: 25px;
  overflow: auto;
  width: 100%;
`;

class StrikeZoneContainer extends React.Component {
  constructor(props) {
    super(props);

    this._handleClick = this._handleClick.bind(this);
  }

  _handleClick() {
    const {
      rootStore: { strikeZoneTableStore: store }
    } = this.props;
    store.routerStore.history.push({
      pathname: store.routerStore.location.pathname,
      search: store.urlParams
    });
  }

  render() {
    const {
      rootStore: { strikeZoneTableStore }
    } = this.props;

    return (
      <Wrapper>
        <FilterSidebar>
          <PitchCriteria store={strikeZoneTableStore} multiVenue />
          <StrikeZoneModelCriteria store={strikeZoneTableStore} />
          <ApplyButton clickHandler={this._handleClick} />
        </FilterSidebar>
        <TableWrapper>
          <h1>Statcast Strike Zone Analysis</h1>
          <p>
            The below table illustrates the percentage of pitches classified as
            a strike by Statcast.
          </p>
          <p>
            Each column represents the horizontal offset from the center of home
            plate, in feet, as seen from the catcher&#39;s point of view. For
            example, &quot;L-060&quot; means 0.6 feet to the left.
          </p>
          {strikeZoneTableStore.isLoading ? (
            <Loading />
          ) : (
            <SetiTable setiData={strikeZoneTableStore.setiData} />
          )}
        </TableWrapper>
      </Wrapper>
    );
  }
}

export default inject("rootStore")(observer(StrikeZoneContainer));



// WEBPACK FOOTER //
// ./src/containers/StrikeZoneContainer.js